export const QUERY_KEY_CURRENT_ACCOUNT = 'CurrentAccount'
